export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    info: Object,
    cancelText: {
      type: String,
      default: 'Cancel'
    },
    confirmText: {
      type: String,
      default: 'Ok'
    },
    popupVisible: {
      type: Boolean,
      default: false
    },
    showCaneclBtn: {
      type: Boolean,
      default: true
    },
    showConfirmBtn: {
      type: Boolean,
      default: true
    },
    confirmEvent: {
      type: Function,
      default: function () {
        return {};
      }
    },
    closeEvent: {
      type: Function,
      default: function () {
        return {};
      }
    }
  },
  methods: {
    changeVal() {
      this.info.show = false;
      this.closeEvent();
    },
    event() {
      this.confirmEvent();
    }
  }
};